import { StoryComment } from 'components/main/story-comment'
export default StoryComment
